import api from "@/libs/api";
import store from "@/store";

const initState = {
  ltv_book_show: "",
  ltv_user_data:"",
};

const ltv = {
  state: initState,
  mutations: {
    SET_LTV_URL(state, status) {
      state.ltv_book_show = status
    },
    SET_USERS_DATA(state,obj){
      state.ltv_user_data = obj
    }
  },
  getters: {},
  actions: {},
};

export default ltv;



// WEBPACK FOOTER //
// ./src/store/modules/ltv.js